import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components'; // Swiper

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper/core';
SwiperCore.use([Pagination, Navigation]);
var Container = styled.div.withConfig({
  displayName: "ImageSlider__Container",
  componentId: "sc-pg6r0r-0"
})([".mySwiper{margin-top:1vw;--swiper-theme-color:#ede6db !important;.swiper-wrapper{.swiper-slide > img{object-fit:contain;width:100%;max-height:50vh;margin-left:auto;margin-right:auto;}}}"]);

var ImageSlider = function ImageSlider(_ref) {
  var images = _ref.images;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(Swiper, {
      pagination: {
        clickable: true
      },
      navigation: true,
      spaceBetween: 30,
      loop: true,
      className: "mySwiper",
      children: images.map(function (image, index) {
        return /*#__PURE__*/_jsx(SwiperSlide, {
          children: /*#__PURE__*/_jsx("img", {
            src: image.image,
            alt: ""
          })
        }, index);
      })
    })
  });
};

export default ImageSlider;